/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '../typography/Typography';
import { Eyebrow } from './Eyebrow';

const defaultVariantMap = {
  h3: {
    variant: 'h3',
    height: 'snug',
    weight: 'condensed',
    lineClamp: '3'
  },
  h5: {
    variant: 'h5',
    height: 'snug',
    weight: 'condensed',
    lineClamp: '3'
  }
};

const CardTitle = React.forwardRef((props, ref) => {

  const {
    action: actionProp,
    actionPosition = 'start',
    disableActionSpacing = false,
    disableTypography = false,
    eyebrow: eyebrowProp,
    eyebrowOrnament,
    header: headerProp,
    headerVariant = 'h3',
    subheader: subheaderProp,
    ...other
  } = props;

  let eyebrow = eyebrowProp;
  if (eyebrow != null || eyebrowOrnament != null) {
    eyebrow = (<Eyebrow title={eyebrow} ornament={eyebrowOrnament} />);
  }

  let header = headerProp;
  if (header != null && header.type !== Typography && !disableTypography) {
    const headerTypographyProps = defaultVariantMap[headerVariant];
    header = (<Typography {...headerTypographyProps}>{header}</Typography>);
  }

  let subheader = subheaderProp;
  if (subheader != null && subheader.type !== Typography && !disableTypography) {
    subheader = (<Typography color="subtle">{subheader}</Typography>);
  }

  let action = actionProp;
  if (action != null) {
    const actionClasses = classNames('sui-grow-0 sui-shrink-0 sui-basis-auto', {
      'sui-self-start': actionPosition === 'start',
      'sui-self-center': actionPosition === 'center',
      'sui-self-end': actionPosition === 'end',
      'sui--mr-2': !disableActionSpacing
    });
    action = (
      <div className={actionClasses}>
        {action}
      </div>
    );
  }

  return (
    <div
      className="sui-flex sui-items-center"
      ref={ref}
      {...other}
    >
      <div className="sui-flex-auto">
        {eyebrow}
        {header}
        {subheader}
      </div>
      {action}
    </div>
  );
});

CardTitle.displayName = 'CardTitle';

CardTitle.propTypes = {
  /**
   * The action ornament, button or link of the title
   */
  action: PropTypes.node,
  /**
   * The position of the action.
   * @default 'start'
   */
  actionPosition: PropTypes.PropTypes.oneOf(['start', 'center', 'end']),
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * If true, the actions do not have additional margin.
   * @default false
   */
  disableActionSpacing: PropTypes.bool,
  /**
   * The contents of the eyebrow.
   */
  eyebrow: PropTypes.string,
  /**
   * The leading ornament within the eyebrow.
   */
  eyebrowOrnament: PropTypes.node,
  /**
   * The contents of the header.
   */
  header: PropTypes.node,
  /**
   * The typography variant to use in header. Either `h3` or `h5`
   * h3: { height: 'snug',  weight: 'condensed', lineClamp: '3' }
   * h5: { height: 'snug',  weight: 'condensed', lineClamp: '3' }
   * @default 'h3'
   */
  headerVariant: PropTypes.oneOf(['h3', 'h5']),
  /**
   * The contents of the subheader.
   */
  subheader: PropTypes.node
};

CardTitle.defaultProps = {};

export { CardTitle };